/** Mirrors what `/api/v1/endpoints/:slug/rules` serialises. */

export interface MockResponse {
  status: number;
  headers: Record<string, string>;
  body?: unknown;
  delayMs?: number;
}

export interface Rule {
  id: string;
  priority: number;
  method: string;
  pathPattern: string;
  response: MockResponse;
  enabled: boolean;
  createdAt: string;
}

export interface Endpoint {
  slug: string;
  url: string;
  name: string | null;
  defaultResponse: MockResponse;
  requestCount: number;
  createdAt: string;
  expiresAt: string;
}

export interface TestResult {
  matched: Rule | null;
  ruleId: string | null;
  params: Record<string, string>;
  response: MockResponse & { delayMs: number };
}

/** `*` plus the verbs anyone actually writes a rule for. */
export const METHODS = ['*', 'GET', 'POST', 'PUT', 'PATCH', 'DELETE', 'HEAD', 'OPTIONS'] as const;

export const MAX_DELAY_MS = 30_000;
